export default function invDateFormat(fecha) {
    let newDate = fecha
    if (newDate === "" || newDate === null || newDate === undefined || newDate.length === 0 || newDate === " ") {
    }
    else {
        let partes = newDate.split("-")
        newDate = new Date(partes[2], partes[1] - 1, partes[0]);
    }
    return newDate
}